import React from "react";

//UI Material
import { Box, Card, Grid, Stack } from "@mui/material";

//Helpers
import {
  typographyForMainTitles,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";

//React charts JS 2
import { Line } from "react-chartjs-2";

export default function ResultsGraph({ data = [], type = "assembly" }) {
  //Function to generate datasets
  const generateDataSets = () => {
    let dataType;

    if (type === "assembly") {
      dataType = data;
    } else {
      dataType = data.filter((d) => d.testedBy);
    }

    let registers = [
      {
        label: "Registros",
        data: new Array(12).fill(0),
        borderColor: new Array(12).fill("white"),
        backgroundColor: new Array(12).fill("white"),
        pointRadius: new Array(12).fill(1),
        tension: 0.2,
      },
    ];

    //Fill order objects iterating trough orders
    for (const register of dataType) {
      try {
        let month;
        if (type === "assembly") {
          month = new Date(register.assemblyAt).getMonth();
        } else {
          month = new Date(register.testedAt).getMonth();
        }

        //Validate month
        if (!isNaN(Number(month))) {
          registers[0].data[month] += 1;
        }
      } catch (e) {
        console.log(e);
        break;
      }
    }

    registers[0].pointRadius[new Date().getMonth()] = 3;
    registers[0].borderColor[new Date().getMonth()] = "#CDF4FF";
    registers[0].backgroundColor[new Date().getMonth()] = "#CDF4FF";

    return registers;
  };

  //Function to get total products
  const totalProducts = () => {
    if (type === "assembly") {
      return data.length;
    } else {
      return data.filter((d) => d.testedBy).length;
    }
  };

  //Function to generate chart data
  const generateChartData = () => ({
    datasets: generateDataSets(),
    labels: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Setiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
  });

  //Function to generate chart options
  const generateChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      y: { display: false, grid: { display: false } },
      x: { display: false, grid: { display: false } },
    },
    plugins: {
      filler: {
        propagate: true,
      },
      legend: {
        position: "bottom",
        display: false,
      },
    },
  };

  return (
    <Card
      raised
      sx={{
        backgroundColor: "#003C3C",
      }}
    >
      <Grid
        container
        spacing={1}
        textAlign="center"
        alignItems="center"
        sx={{ padding: "15px" }}
      >
        <Grid item xs={8}>
          <Stack justifyContent="center" alignItems="center">
            {typographyForSubtitles(
              `${
                type === "assembly" ? "Ensamblados" : "Probados"
              } ${new Date().getFullYear()}`,
              "white"
            )}
            <Stack direction="row" alignItems="center" spacing={1}>
              {typographyForMainTitles(totalProducts(), "white")}
              {typographyForText(`productos`, null, "white")}
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={4}>
          <Box>
            <Line options={generateChartOptions} data={generateChartData()} />
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
}
